<template>
<section class="relative w-full font-poppin ">
    <div 
      class="h-full bg-cover bg-center relative"
      :style="{ backgroundImage: `url(${require('@/assets/bg-img.png')})` }"
    >
      <div class="absolute inset-0 bg-[#186a85]/70"></div>
  
      <!-- Konten Visi Misi -->
      <div class="relative z-10 mt-6 flex justify-center space-x-8 pt-12 text-center xl:gap-32  antialiased">
        <div class="flex flex-col items-center space-y-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-12 h-12">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
          </svg>
          <div class="text-6xl font-bold text-white">9</div>
          <div class="text-white">Years of Experience</div>
        </div>
  
        <div class="flex flex-col items-center space-y-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-12 h-12">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
          </svg>
          <div class="text-6xl font-bold text-white">5</div>
          <div class="text-white">Completed Projects</div>
        </div>
  
        <div class="flex flex-col items-center space-y-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-12 h-12">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
          </svg>
          <div class="text-6xl font-bold text-white">17</div>
          <div class="text-white">Happy Clients</div>
        </div>
      </div>
  
      <div class="relative z-10 container mx-auto px-4 py-20  text-justify antialiased">
        <div class="bg-white rounded-2xl shadow-lg p-8 max-w-7xl mx-auto">
          <div class="text-center mb-8">
            <div class="flex justify-center items-center mb-6">
              <div class="h-8 rounded-lg w-1 bg-[#186a85]"></div>
              <span class="px-2 py-2 text-[#186a85] font-normal xl:text-3xl lg:text-2xl md:text-2xl text-lg tracking-wider">
                Vision and Mission
              </span>
            </div>
          </div>
  
          <div class="grid md:grid-cols-1 gap-8">
            <div>
              <h3 class="text-3xl font-normal text-black mb-4">Our Vision</h3>
              <p class="text-gray-700 leading-relaxed">
                To become a leading national scale public company, known as a reliable partner that can provide the best information technology solutions generally for the people of Indonesia and especially for partner companies.
              </p>
            </div>
  
            <div>
              <h3 class="text-3xl font-normal text-black mb-4">Our Mission</h3>
              <ul class="text-gray-700 space-y-3 list-disc pl-5">
                <li>Prioritize the professionalism and competence of the team to produce the integrated system between apps that can help reduce problems and can increase the profit growth of our partner companies.</li>
                <li>Turning information technology challenges into beneficial opportunities and perfect solutions generally for society and especially for partner companies.</li>
                <li>Establish cooperation with business partners in distributing superior products and information technology solutions.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </template>

<script>

export default {
  name: 'VisiMisi',
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    // Simple entrance animation
    setTimeout(() => {
      this.visible = true;
    }, 100);
    
  },
};
</script>
<style>

</style>